import React from 'react';
import { Card, Tag, Progress } from 'antd';

const ComplianceMatches = ({ scorecard, data }) => {
  const { match, no_match, errors, total } = data;
  const validTotal = total - errors;
  const matchRate = validTotal > 0 ? (match / validTotal) * 100 : 0;
  const noMatchRate = validTotal > 0 ? (no_match / validTotal) * 100 : 0;

  return (
    <Card 
      size="small"
      title={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ color: '#ffffff', fontWeight: '600', fontSize: '14px' }}>
            Scorecard {scorecard} Compliance
          </span>
          <Tag 
            size="small" 
            color="purple"
            style={{ fontSize: '10px', fontWeight: '500' }}
          >
            Match-Based
          </Tag>
        </div>
      }
      style={{ 
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        marginBottom: '12px'
      }}
    >
      <div style={{ marginBottom: '12px' }}>
        <div style={{ 
          display: 'flex', 
          height: '40px', 
          borderRadius: '4px', 
          overflow: 'hidden',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div
            style={{
              backgroundColor: '#f44336',
              width: `${matchRate}%`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '12px',
              fontWeight: 'bold',
              minWidth: matchRate > 15 ? 'auto' : '0px',
              transition: 'all 0.3s ease'
            }}
            title={`Matches: ${match} apps (${matchRate.toFixed(1)}%)`}
          >
            {matchRate > 15 && <span>Issues: {match}</span>}
          </div>
          <div
            style={{
              backgroundColor: '#4CAF50',
              width: `${noMatchRate}%`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '12px',
              fontWeight: 'bold',
              minWidth: noMatchRate > 15 ? 'auto' : '0px',
              transition: 'all 0.3s ease'
            }}
            title={`No Matches: ${no_match} apps (${noMatchRate.toFixed(1)}%)`}
          >
            {noMatchRate > 15 && <span>Clean: {no_match}</span>}
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div 
              style={{ 
                width: '12px', 
                height: '12px', 
                backgroundColor: '#f44336', 
                borderRadius: '2px' 
              }}
            />
            <span style={{ color: '#e2e8f0', fontSize: '13px' }}>
              Compliance Issues Found
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ color: '#ffffff', fontWeight: '600', fontSize: '14px' }}>
              {match}
            </span>
            <span style={{ color: '#94a3b8', fontSize: '12px' }}>
              ({matchRate.toFixed(1)}%)
            </span>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div 
              style={{ 
                width: '12px', 
                height: '12px', 
                backgroundColor: '#4CAF50', 
                borderRadius: '2px' 
              }}
            />
            <span style={{ color: '#e2e8f0', fontSize: '13px' }}>
              No Compliance Issues
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ color: '#ffffff', fontWeight: '600', fontSize: '14px' }}>
              {no_match}
            </span>
            <span style={{ color: '#94a3b8', fontSize: '12px' }}>
              ({noMatchRate.toFixed(1)}%)
            </span>
          </div>
        </div>
      </div>

      {errors > 0 && (
        <div style={{ 
          marginTop: '12px', 
          padding: '8px 12px', 
          backgroundColor: 'rgba(239, 68, 68, 0.1)',
          border: '1px solid rgba(239, 68, 68, 0.3)',
          borderRadius: '4px'
        }}>
          <span style={{ color: '#fca5a5', fontSize: '12px' }}>
            ⚠️ {errors} apps with missing/invalid data
          </span>
        </div>
      )}

      <div style={{ 
        marginTop: '12px', 
        paddingTop: '8px', 
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        fontSize: '12px',
        color: '#94a3b8'
      }}>
        Total evaluated: {validTotal} of {total} apps
      </div>
    </Card>
  );
};

export default ComplianceMatches;